import { produce } from 'immer';
import { find, findIndex } from 'lodash/fp';
import { extractError } from 'app/lib/error';
import { getExtractedColumnName } from 'app/lib/utils/parseJson';
import {
    SELECT_COLUMN,
    CLOSE_EDITOR,
    SELECT_JSON_NODE,
    TOGGLE_EXTRACT_JSON,
    UPDATE_TYPE,
    INITIALIZE_STATE,
    CREATE_EXTRACT_JSON,
    UPDATE_EXTRACT_JSON,
    CLEAR_EXTRACTED_COLUMNS,
    CALC_METRICS_FROM_PREVIEW,
    TOGGLE_EXPAND_ARRAY
} from './types.js';

export const INITIAL_STATE = {
    selectedColumn: null,
    selectedJsonNode: null,
    extractedColumns: [],
    isRunningQuery: false,
    isSaving: false,
    error: null,
    selectedColumnName: null,
    paths: [],
    previewMetrics: null
};

export const extractJsonReducer = produce((draft, action) => {
    switch (action.type) {
        case INITIALIZE_STATE: {
            const { selectedColumnName, extracts, outputs } = action.payload;

            draft.extractedColumns = extracts.map((extract, index) => ({
                path: extract.path.split('::')[0],
                type: outputs[index].type,
                expand: extract.expand
            }));

            const isTopLevelArray = extracts[0]?.path.startsWith('.') && extracts[0]?.expand;

            if (isTopLevelArray) {
                draft.selectedJsonNode = '.';
            }

            draft.selectedColumn = { name: selectedColumnName, isArray: isTopLevelArray };
            break;
        }
        case TOGGLE_EXTRACT_JSON: {
            const { path, type, expand } = action.payload;
            if (find({ path }, draft.extractedColumns)) {
                draft.extractedColumns = draft.extractedColumns.filter(
                    (column) => column.path !== path
                );
                draft.selectedColumnName = null;
            } else {
                draft.extractedColumns.push({ path, type, expand });
                draft.selectedColumnName = getExtractedColumnName(path);
            }

            break;
        }
        case TOGGLE_EXPAND_ARRAY: {
            const { path } = action.payload;
            const index = findIndex({ path }, draft.extractedColumns);
            draft.extractedColumns[index].expand = !draft.extractedColumns[index].expand;
            break;
        }
        case UPDATE_TYPE: {
            const { path, type } = action.payload;
            const index = findIndex({ path }, draft.extractedColumns);
            draft.extractedColumns[index].type = type;
            break;
        }
        case SELECT_JSON_NODE: {
            const path = action.payload;
            draft.selectedJsonNode = path ? action.payload : null;
            const index = findIndex({ path }, draft.extractedColumns);
            if (index >= 0) {
                draft.selectedColumnName = getExtractedColumnName(path);
            }
            break;
        }
        case SELECT_COLUMN:
            draft.selectedColumn = action.payload;
            draft.selectedColumnName = action.payload?.name;
            draft.paths = [];
            draft.previewMetrics = null;
            draft.selectedJsonNode = '.';
            break;
        case CLEAR_EXTRACTED_COLUMNS:
            draft.extractedColumns = [];
            break;
        case CALC_METRICS_FROM_PREVIEW: {
            draft.paths = action.payload.paths;
            draft.previewMetrics = action.payload.metrics;
            break;
        }
        case CLOSE_EDITOR:
            draft.selectedColumn = null;
            draft.selectedColumnName = null;
            draft.selectedJsonNode = null;
            draft.extractedColumns = [];
            draft.error = null;
            draft.paths = [];
            draft.previewMetrics = null;
            break;

        case CREATE_EXTRACT_JSON.STARTED:
        case UPDATE_EXTRACT_JSON.STARTED:
            draft.isRunningQuery = true;
            draft.isSaving = true;
            break;
        case CREATE_EXTRACT_JSON.ENDED:
        case UPDATE_EXTRACT_JSON.ENDED:
            draft.isRunningQuery = false;
            draft.isSaving = false;
            break;
        case CREATE_EXTRACT_JSON.REJECTED:
        case CREATE_EXTRACT_JSON.FAILED:
        case UPDATE_EXTRACT_JSON.REJECTED:
        case UPDATE_EXTRACT_JSON.FAILED: {
            draft.error = extractError(action.payload);
            break;
        }
        default:
            break;
    }
}, INITIAL_STATE);
